<template>
    <div class="container feedback template-bg-gray my-position-relative">
        <md-card class="request-status loop_container bg-transparent update-request-form-common">
            <md-card-content class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
                <div class="card form-wrapper text-center p-20">
                    <h4 class="template-custom-title" v-if="!message.length">checking...</h4>
                    <h4 class="template-custom-title" else>{{message}}</h4>
                </div>
            </md-card-content>
	    </md-card>
    </div>
</template>

<script>
import API from "../services/API";
export default {
    name: 'UpdateRequestStatus',
    props: ['communityId', 'ask_id', 'status'],
    data() {
        return {
            fullPage: true,
            api: new API(),
            message: ''
        }
    },
    beforeCreate() {
        if (this.$route.query.type && this.$route.query.type === 'request') {
            if (!this.$route.query.askid || !this.$route.query.status) {
                this.$router.push('/');
            }
        } else if (this.$route.query.type && this.$route.query.type === 'response') {
            if (!this.$route.query.askid || !this.$route.query.giveid || !this.$route.query.status) {
                this.$router.push('/');
            }
        }
    },
    async created() {
        localStorage.setItem('community_id', this.communityId);
        await this.$nextTick(); // Ensure localStorage is committed before API calls
        if (this.$route.query.type === 'request') {
            await this.api.get(`asks/${this.$route.query.askid}`).then(async ask => {
                if (ask && ask.data.status && ask.data._id && ask.data.status === 'Pending') {
                // if (ask && ask.data.status && ask.data._id && (ask.data.status === 'Pending' || (typeof ask.data.superUserApproveDate === 'undefined'))) {
                    await this.api.post(`asks/update-request-status`, {askId: this.$route.query.askid, status: this.status}).then(response => {
                        if (this.status === 'approve') {
                            this.$gtm.enable(true)
                            this.$gtm.trackEvent({
                                'RequestID': ask.data._id,
                                'RequestSource': 'Web',
                                'RequestReceived': this.$moment(ask.data.createdAt).tz("America/New_York").format('YYYYMMDD'),
                                'Community': ask.data.community.name,
                                'SuperUserID': '',
                                'event': 'SuperUserApprove'
                            });
                            this.message = 'Request is approved';
                        } else if (this.status === 'reject') {
                            this.$gtm.enable(true)
                            this.$gtm.trackEvent({
                                'RequestID': ask.data._id,
                                'RequestSource': 'Web',
                                'RequestReceived': this.$moment(ask.data.createdAt).tz("America/New_York").format('YYYYMMDD'),
                                'Community': ask.data.community.name,
                                'SuperUserID': '',
                                'event': 'SuperUserReject'
                            });
                            this.message = 'Request is rejected';
                        } else {
                            this.message = 'Thank you';
                        }
                    });
                } else {
                    this.message = 'Thank you';
                }
            }).catch(err => {
                console.log('err', err);
                this.$toast.error('Something went wrong');
            });
        } else if (this.$route.query.type === 'response') {
            await this.api.get(`asks/${this.$route.query.askid}`).then(async ask => {
                if (ask) {
                    var give = [];
                    if (ask.data.gives) {
                        give = ask.data.gives.filter(give => give._id === this.$route.query.giveid);
                    }
                    if (give.length && ask.data._id && give[0].responseState.currentState === 'Pending' && ask.data.status !== '(8) Rejected' && ask.data.status !== '(7) Closed') {
                        await this.api.post(`asks/update-response-status`, {askId: this.$route.query.askid, giveId: this.$route.query.giveid, status: this.status, communityId: this.communityId}).then(response => {
                            if (this.status === 'approve') {
                                this.message = 'Response is approved';
                            } else if (this.status === 'reject') {
                                this.message = 'Response is rejected';
                            } else {
                                this.message = 'Thank you';
                            }
                        });
                    } else {
                        this.message = 'Thank you';
                    }
                } else {
                    this.message = 'Thank you';
                }
            }).catch(err => {
                console.log('err', err);
                this.$toast.error('Something went wrong');
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/UpdateRequestStatus.vue